import { useState, useLayoutEffect, useCallback } from 'react';
import { IMediaQuery } from './useMediaQuery.model';
import { getMatches, getMediaQueries, processResult } from './utils/utils';

export const useMediaQuery = (): IMediaQuery => {
  const [values, setValues] = useState<IMediaQuery>(getMatches());

  const changeHandler = useCallback(() => {
    setValues(getMatches());
  }, []);

  useLayoutEffect(() => {
    const matchList = Object.values(getMediaQueries());

    matchList.forEach((query) =>
      query.addEventListener('change', changeHandler),
    );

    return () =>
      matchList.forEach((query) =>
        query.removeEventListener('change', changeHandler),
      );
  }, []);

  return processResult(values);
};
